import React, {Component} from 'react'
import styles from './FJPopover.module.less';
import saveClose from '../../../icon/saveclose.svg';
import InlineSVG from "react-inlinesvg";
import classNames from 'classnames';

class FJPopover extends Component {

  render() {
    let {
      onCancel,
      isShow,
      content,
      btnMsg,
    } = this.props;

    let width = 362;
    let top = 0;
    let left = -width - 2;

    return (
      <div className={styles.box} style={{width: width, top: top, left: left, display: isShow ? 'block' : 'none'}}>
        <div className={styles.close} onClick={onCancel}><InlineSVG src={saveClose}/></div>
        <div className={styles.desc}>{content}</div>
        <div className={styles.btn_box}>
          {
            btnMsg.map(item => {
              return <div className={classNames(styles.btn, styles[item.btnClassName])} onClick={item.onClick} key={item.btnText}>{item.btnText}</div>
            })
          }
        </div>
      </div>
    )
  }
}

export default FJPopover;
